import { configureStore } from "@reduxjs/toolkit";
import { productApi } from "./features/product/productApi";
import filterReducer from "./features/filter/filterSlice";
import authReducer from "./features/auth/authSlice";
import productReducer from "./features/product/addProductSlice";
import favoriteReducer from "./features/Favorites";
import { authApi } from "./features/auth/authApi";
import { autoCompleteApi } from "./features/location/autoCompleteApi";
import { geocodeApi } from "./features/location/GeocodeApi";
export const store = (options) =>
  configureStore({
    reducer: {
      // filter: filterReducer,
      filter: filterReducer,
      // product: productReducer,
      product: productReducer,
      favorite: favoriteReducer,
      // productApi: productApi.reducer,
      [productApi.reducerPath]: productApi.reducer,
      [autoCompleteApi.reducerPath]: autoCompleteApi.reducer,
      [geocodeApi.reducerPath]: geocodeApi.reducer,

      // authApi: authApi.reducer,
      [authApi.reducerPath]: authApi.reducer,
      auth: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(autoCompleteApi.middleware)
        .concat(geocodeApi.middleware)
        .concat(productApi.middleware)
        .concat(authApi.middleware),
    ...options,
  });
